const getArticleSpotName = (article, order) => article.spotName || order.spotName || '';

const getArticleQuantity = article => article.quantity || article.amount || 1;

export function getSidebarArticleKey(article, order, localSettings = {}) {
  const splitOutFeatures = localSettings && localSettings.splitSideDishes;
  const key = [(article.name || '').trim()];

  if (!splitOutFeatures) {
    key.push(...(article.features || []));
  }

  if (localSettings && localSettings.groupSidebarBySpotName) {
    key.push(getArticleSpotName(article, order));
  }

  return JSON.stringify(key);
}

const getSidebarFeatureKey = (feature, article, order, localSettings = {}) => {
  const key = ['feature', feature.feature || '', feature.value || ''];

  if (localSettings && localSettings.groupSidebarBySpotName) {
    key.push(getArticleSpotName(article, order));
  }

  return JSON.stringify(key);
};

export function buildSidebarArticles(orders, localSettings = {}) {
  const splitOutFeatures = localSettings && localSettings.splitSideDishes;
  const articlemap = new Map();

  orders.forEach(order =>
    order.articles.forEach((article) => {
      const articleKey = (article.name || '').trim();
      const key = getSidebarArticleKey(article, order, localSettings);
      const spotName = getArticleSpotName(article, order);

      let currentValue = articlemap.get(key);

      if (typeof currentValue === 'undefined') {
        currentValue = {
          name: articleKey,
          features: splitOutFeatures ? [] : article.features,
          quantity: 0,
          labelPrintCount: 0,
          entries: [],
          stateName: article.stateName,
          productionPlaceId: article.productionPlaceId || order.productionPlaceId,
          spotName,
        };
      }

      currentValue.entries.push({
        id: article.id,
        quantity: getArticleQuantity(article),
        labelPrintCount: article.labelPrintCount,
      });

      currentValue.labelPrintCount += (article.labelPrintCount || 0);
      currentValue.quantity += getArticleQuantity(article);

      if (splitOutFeatures && article.featuresUnmapped) {
        article.featuresUnmapped.forEach((feature) => {
          const featureKey = getSidebarFeatureKey(feature, article, order, localSettings);
          let currentFeature = articlemap.get(featureKey);

          if (typeof currentFeature === 'undefined') {
            currentFeature = {
              name: feature.value || feature.feature || '',
              features: [],
              quantity: 0,
              productionPlaceId: article.productionPlaceId || order.productionPlaceId,
              stateName: article.stateName,
              spotName,
            };
          }

          currentFeature.quantity += (feature.amount || 0);

          articlemap.set(featureKey, currentFeature);
        });
      }

      articlemap.set(key, currentValue);
    }),
  );

  const articles = [];

  for (const article of articlemap.values()) {
    articles.push({
      name: article.name,
      quantity: article.quantity,
      features: article.features,
      entries: article.entries,
      labelPrintCount: article.labelPrintCount,
      productionPlaceId: article.productionPlaceId,
      stateName: article.stateName,
      spotName: article.spotName,
    });
  }

  return articles;
}
